<template>
  <div class="app-table-container">
    <!-- 查询条件 -->
    <el-form :model="queryForm">
        <el-row>
          <el-col :span="6">
            <el-form-item label="昵称" :label-width="formLabelWidth">
              <el-input v-model="queryForm.name" maxlength="9" size="small" placeholder="请输入昵称" />
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-form-item :label-width="formLabelWidth">
              <el-button type="primary" size="small" @click="handlePage(1)">搜索</el-button>
              <el-button size="small" @click="reset()">重置</el-button>
            </el-form-item>
          </el-col>
      </el-row>
    </el-form>
    <!-- 数据表格 -->
    <el-table
      stripe
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
      :data="tableData"
      :height="tableHeight"
      ref="tableContainer"
      class="table-container">
      <el-table-column
        fixed
        prop="avatarId"
        label="头像">
        <template slot-scope="scope">
          <img style="width: 60px;" :src="scope.row.avatarId"/>
        </template>
      </el-table-column>

      <el-table-column
        fixed
        prop="authName"
        label="姓名"/>

      <el-table-column
        fixed
        prop="authGender"
        label="性别">
        <template slot-scope="scope">
          {{scope.row.authGenderLabel}}
        </template>
      </el-table-column>

      <el-table-column
        prop="authPhone"
        label="手机号"
        :show-overflow-tooltip="true" />

      <el-table-column
        prop="authWeixin"
        label="微信号"
        :show-overflow-tooltip="true" />

      <el-table-column
        prop="auditState"
        label="审核状态"
        min-width="100px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.auditState=='SUCCESS'" size="mini" type="success" round>{{scope.row.auditStateLabel}}</el-button>
          <el-button v-if="scope.row.auditState=='NEW'" size="mini" type="warning" round>{{scope.row.auditStateLabel}}</el-button>
          <el-button v-if="scope.row.auditState=='FAIL'" size="mini" type="danger" round>{{scope.row.auditStateLabel}}</el-button>
        </template>
      </el-table-column>

      <el-table-column
        prop="auditReason"
        label="审核原因"
        :show-overflow-tooltip="true" />

      <el-table-column
        prop="lastLoginTime"
        label="最近登录"
        min-width="170px"/>

      <el-table-column
        prop="createTime"
        label="注册时间"
        min-width="165px"/>

      <el-table-column fixed="right" min-width="200px">
        <template slot="header">
          <span style="float: left">操作</span>
          <!-- <el-button
              style="float: right;"
              type="primary" size="mini"
              v-if="$permits.has(targetPermit,$permits.CREATE)"
              @click="handleAction($permits.CREATE)">
            + 新建
          </el-button> -->
        </template>
        <template slot-scope="scope">
          <!-- <el-button v-show="$permits.has(targetPermit,$permits.VIEW)" @click="handleAction($permits.VIEW,scope.row)" size="mini" type="success" round>详情</el-button> -->
          <el-button v-if="$permits.has(targetPermit,$permits.UPDATE)" @click="handleAction($permits.UPDATE,scope.row)" size="mini" type="warning" round>审核</el-button>
          <!-- <el-button v-if="$permits.has(targetPermit,$permits.REMOVE)" @click="handleRemove(scope.row)" size="mini" type="danger" round>删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-row>
      <el-col>
        <div class="pagination">
          <el-pagination background
            v-if="paginations.total>0"
            :page-sizes="paginations.pages"
            :page-size="paginations.size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page.sync="paginations.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </el-col>
    </el-row>
    <AccountForm v-if="control.show" :control="control" :enums="enums" :departments="departments" />

  </div>
</template>
<script>
import * as DepartmentApi from '@/api/department'
import * as EnumApi from '@/api/enums'
import * as AccountApi from '@/api/account'
import * as RoleApi from '@/api/role'
import AccountForm from './form'
export default {
  name: 'Account',
  components: {
    AccountForm
  },
  data() {
    return {
      formLabelWidth: '80px',
      enums: [],
    	// 权限key
      targetPermit: 'account',
      tableHeight: 0,
      roleVisible: false,
      currentAccount: {},
      roleList: [],
      roleIds: [],
      queryForm: {
        name: '',
        adminFlag: false,
        merchantFlag: false,
        fromType: 'kol',
        current: '',
        size: ''
      },
      control: {
        show: false,
        title: '',
        action: this.$permits.VIEW,
        form: '',
        disabled: false
      },
      tableData: [],
      departments: [],
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 10, // 每页行数
        sizes: [10, 20, 30, 40], // 每页行数 调整
        layout: 'total, sizes, prev, pager, next, jumper' // 翻页属性
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.tableContainer.$el.offsetHeight;
    })
    this.handlePage()
    this.handleEnum()
  },
  methods: {
    // 重置
    reset() {
      Object.keys(this.queryForm).forEach(key => (this.queryForm[key] = ''))
      this.handlePage()
    },
    handleAction(action,item) {
      let that = this;
      console.log("action >> " + action)
      that.control.show = true;
      that.control.disabled = false;
      that.control.action = action;

      switch(action){
        case that.$permits.VIEW:
          that.control.title = "详情";
          that.control.disabled = true;
          that.control.form = item;
          console.log("switch >>> " + that.$permits.VIEW)
          break;
        case that.$permits.UPDATE:
          that.control.title = "编辑";
          that.control.form = item;
          console.log("switch >>> " + that.$permits.UPDATE)
          break;
        case that.$permits.CREATE:
          that.control.title = "新建";
          console.log("switch >>> " + that.$permits.CREATE)
          break;
      }
    },
    handleRemove(item) {
      let that = this;
      that.$confirm('', '确定删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        AccountApi.remove(item.id).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleStop(item) {
      let that = this;
      that.$confirm('', '确定停用吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        AccountApi.enabled({id: item.id, enabled: false}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleStart(item) {
      let that = this;
      that.$confirm('', '确定启用吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        AccountApi.enabled({id: item.id, enabled: true}).then(res => {
          that.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    handleEnum() {
      let that = this;
      // 获取表格数据
      EnumApi.list().then(res => {
        let result = res.data.data;
        that.enums = result
      })
    },
    handlePage(current) {
      let that = this;
      if (current) {
        that.paginations.current = current
      }
      that.queryForm.current = that.paginations.current
      that.queryForm.size = that.paginations.size
      // 获取表格数据
      AccountApi.page(that.queryForm).then(res => {
        let result = res.data.data;
        that.tableData = result.records||[]
        that.paginations.total = Number(result.total)
        that.paginations.current = Number(result.current)
        that.paginations.size = Number(result.size)
      })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
